export interface SendServiceNotificationEmail {
  serviceCaseId: string;
  body: SendCheckinNotificationEmailBody;
}

export interface SendCheckinNotificationEmailBody {
  recipients: SendServiceNotificationEmailRecipients[];
  digitalCertificateUrl: string;
  attachments: SendServiceNotificationEmailAttachment[];
  smtpCredentialsId?: string;
}

export interface SendServiceNotificationEmailRecipients {
  email: string;
  customerId: string | null;
}

export interface SendServiceNotificationEmailAttachment {
  name: string;
  url: string;
}
